import React from "react";

const FullscreenVideoPlayer = ({ isPlaying, closeVideoScreen, videoRef, videoUrl }) => {

// Close Fullscreen Player
const closeVideoPlayer = () => {
  closeVideoScreen()
  if (videoRef.current) {
    videoRef.current.pause();
    videoRef.current.currentTime = 0; // Reset video
  }
};

// Auto-close after video ends
const handleVideoEnd = () => {
  closeVideoPlayer();
};

  return (
    <div>
      {/* Fullscreen video overlay */}
      {isPlaying && (
        <div style={overlayStyles}>
          {/* iframe is for youtube embed video */}
          {/* <iframe 
            width="90%" 
            height="90%" 
            src="https://www.youtube.com/embed/BNRw9eH11Hk?autoplay=1&fs=0&playsinline=1" 
            title="YouTube video player" 
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            allowfullscreen>
          </iframe> */}
           {/* video tag is for .mp4 video */}
          <video
            ref={videoRef}
            src={videoUrl}
            playsinline
            webkit-playsinline
            controls
            autoPlay
            onEnded={handleVideoEnd}
            style={videoStyles}
            controlslist="nodownload noplaybackrate nofullscreen"
            disablePictureInPicture
          ></video>
          <button onClick={closeVideoPlayer} style={closeButtonStyles}>
            x
          </button>
        </div>
      )}
    </div>
  );
};

// CSS-in-JS styles

const overlayStyles = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0, 0, 0, 0.9)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
};

const videoStyles = {
  maxWidth: "100%",
  maxHeight: "100%",
  borderRadius: "10px",
  width: "100%",
  height: "auto",
};

const closeButtonStyles = {
  position: "absolute",
  top: "5px",
  right: "15px",
  backgroundColor: "#ff0000",
  color: "#fff",
  border: "none",
  borderRadius: "50%",
  cursor: "pointer",
  width: "30px",
  height: "30px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
};

export default FullscreenVideoPlayer;
